<template>
  <div class="flex items-center justify-end gap-1" data-cy="team-actions-cell">
    <SButton
      type="button"
      variant="ghost"
      size="icon"
      :disabled="editDisabled"
      :title="editTitle"
      data-cy="team-edit-button"
      @click="$emit('edit')"
    >
      <SquarePenIcon class="h-4 w-4" />
    </SButton>
    <SButton
      type="button"
      variant="ghost"
      size="icon"
      :disabled="removeDisabled"
      :title="$t('team.remove-user')"
      data-cy="team-remove-button"
      @click="$emit('remove')"
    >
      <Trash2Icon class="h-4 w-4 text-destructive" />
    </SButton>
  </div>
</template>

<script setup lang="ts">
import { SButton } from "@smeetz/ui-core";
import { SquarePenIcon, Trash2Icon } from "@smeetz/ui-icons";

defineProps<{
  /** Disabled offline, and for PIN members (managed from the back office). */
  editDisabled: boolean;
  /** Tooltip explaining the edit action or why it is unavailable. */
  editTitle: string;
  /** Disabled offline; the guardrails themselves fail loudly on click. */
  removeDisabled: boolean;
}>();

defineEmits<{
  (event: "edit"): void;
  (event: "remove"): void;
}>();
</script>
